import type { FC } from 'react';
import AntModal from 'antd/es/modal';
import type { ModalProps as AntModalProps } from 'antd/es/modal';
import { cn } from 'app/lib/utils';
import { useDevice } from 'app/hooks/compactTouchUI/DeviceContext';

export interface ModalProps extends AntModalProps {}

/**
 * Dialog façade over antd `Modal`.
 */
const ModalBase: FC<ModalProps> = ({ className, centered, width, ...rest }) => {
  const { isMobileUI } = useDevice();

  return (
    <AntModal
      // Touch gets a centred, gutter-to-gutter dialog by default so no caller has to restate it.
      // Both stay overridable: an explicit `centered` or `width` from the caller wins.
      centered={centered ?? isMobileUI}
      width={width ?? (isMobileUI ? 'calc(100vw - 2rem)' : undefined)}
      className={cn(className)}
      {...rest}
    />
  );
};

// Static confirm keeps antd's API; re-exported so callers never import antd for it.
export const Modal = Object.assign(ModalBase, { confirm: AntModal.confirm });

export default Modal;
